import { ChartJsLine } from "./base";

const Line: typeof ChartJsLine = ({ data, ...props }) => (
  <ChartJsLine data={data} {...props} />
);

export default Line;
